import 'core-js/modules/es.object.assign.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { styled, Stack, palette, spacing, breakpoints, useIsMobile } from '@hub-la/design-system';
import { isEmpty } from 'lodash';
import { memo, useEffect } from 'react';
import { CheckSectionMustBeExpanded } from '../../../usecases/check-section-must-be-expanded.js';
import { useRealtimeSections } from '../../hooks/use-realtime-sections.js';
import '@hub-la/fe-container';
import '@hub-la/fe-core-http-client';
import 'react-query';
import '../../../usecases/save-file.js';
import '../../../domain/dtos/query-key.js';
import '../../../usecases/save-post.js';
import 'core-js/modules/es.array.iterator.js';
import 'core-js/modules/web.dom-collections.iterator.js';
import { useGetSections } from '../../hooks/use-get-sections.js';
import { LoadingState } from './loading-state.js';
import { SidebarContent } from './sidebar-content.js';
import { SidebarHeader } from './sidebar-header.js';

let _ = t => t,
  _t;
const Container = styled(Stack)(_t || (_t = _`
  background-color: ${0};
  width: 100%;
  border-radius: 8px;
  margin-left: 0;
  margin-top: ${0};

  ${0} {
    margin-left: ${0};
    width: 395px;
    margin-top: 0;
  }
`), palette('background'), spacing(6), breakpoints.up('md'), spacing(7.5));
const Sidebar = /*#__PURE__*/memo(({
  productId,
  post,
  isBeta: _isBeta = false
}) => {
  const {
    isFetching,
    data
  } = useGetSections({
    productId
  }, _isBeta);
  const dataSource = data !== null && data !== void 0 ? data : [];
  const isLoading = isFetching && isEmpty(data);
  const isMobile = useIsMobile();
  const {
    dispatch
  } = useRealtimeSections();
  useEffect(() => {
    dispatch({
      type: 'add',
      sections: data !== null && data !== void 0 ? data : []
    });
  }, [data, dispatch]);
  const defaultSection = new CheckSectionMustBeExpanded().execute({
    sections: dataSource,
    postId: post.id
  });
  if (isLoading || !data) {
    return jsx(Container, {
      children: jsx(LoadingState, {})
    });
  }
  return jsxs(Container, Object.assign({
    "data-testid": "sidebar"
  }, {
    children: [!isMobile && jsx(Stack, Object.assign({
      "data-testid": "mobile-desktop-header"
    }, {
      children: jsx(SidebarHeader, {
        productId: productId,
        isBeta: _isBeta
      })
    })), jsx(SidebarContent, {
      defaultSection: defaultSection,
      postId: post.id,
      productId: productId
    })]
  }));
});

export { Sidebar };
